// extracted by mini-css-extract-plugin
export var chevron = "_kr-3";
export var chevronRotated = "_kr-4";
export var image = "_kr-1";
export var imageContainer = "_kr-0";
export var shippingAddress = "_kr-2";